import { LoadingButton } from '@mui/lab';
import { Typography } from '@mui/material';
import { SubmitHandler, useFormContext } from 'react-hook-form';

import { ConfirmDialog } from '../confirm-dialog';
import { RHFTextField } from '@app/components';
interface Props {
  visible: boolean;
  title: string;
  caption: string;
  confirmationButtonTitle: string;
  loading?: boolean;
  onClickConfirm: (reason: string) => void;
  onClose: VoidFunction;
}

const ConfirmationDialog = ({
  visible,
  title,
  caption,
  loading,
  onClickConfirm,
  onClose,
  confirmationButtonTitle,
}: Props) => {
  const { handleSubmit } = useFormContext();

  const handleConfirmClick: SubmitHandler<Record<string, any>> = (data) => {
    onClickConfirm(data.reason);
  };

  return (
    <ConfirmDialog
      title={title}
      content={
        <>
          <Typography>{caption}</Typography>
          <RHFTextField
            required
            name="reason"
            label="Reason"
            variant="outlined"
            fullWidth
            multiline
            minRows={3}
            sx={{ marginTop: '5px' }}
          />
        </>
      }
      onClose={onClose}
      open={visible}
      action={
        <LoadingButton
          variant="contained"
          color="error"
          type="submit"
          sx={{ bgcolor: 'error.dark' }}
          loading={loading}
          onClick={handleSubmit(handleConfirmClick)}
        >
          {confirmationButtonTitle}
        </LoadingButton>
      }
    />
  );
};

export default ConfirmationDialog;
